import axios from 'axios'
import { useAuthStore } from 'features/auth/store/authStore'

import configManager from '../../config/configManager'
const configData = configManager()

const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user`

const axiosInterceptorInstance = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
})

axiosInterceptorInstance.interceptors.request.use(
  (config) => {
    const { role } = useAuthStore.getState()

    config.headers['X-Revvit-role'] = role

    return config
  },

  (error) => {
    return Promise.reject(error)
  },
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve()
    }
  })
  failedQueue = []
}

axiosInterceptorInstance.interceptors.response.use(
  async (response) => {
    // If not already checked, make request to /auth/check
    // if (!hasCheckedTestMode) {
    //   hasCheckedTestMode = true

    //   try {
    //     const checkResponse = await axiosInterceptorInstance.get(
    //       '/auth/user/check-mode',
    //     )
    //     if (checkResponse.data?.isTestMode === true) {
    //       const event = new CustomEvent('triggerPadPopup')
    //       window.dispatchEvent(event)
    //     }
    //   } catch (err) {
    //     console.error('Error checking mode:', err)
    //   }
    // }

    return response
  },
  async (error) => {
    const originalRequest = error.config
    const { response } = error

    if (response?.status === 404) {
      const event = new CustomEvent('historyChange', {
        detail: { path: '/' },
      })
      error.isErrorHandled = true
      window.dispatchEvent(event)
    }

    if (response?.status === 401 && window.location.pathname !== '/login') {
      if (originalRequest.url?.includes('/auth/refresh')) {
        logoutUser()
        return Promise.reject(error)
      }

      if (!originalRequest._retry) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject })
          })
            .then(() => {
              return axiosInterceptorInstance(originalRequest)
            })
            .catch((err) => {
              return Promise.reject(err)
            })
        }

        originalRequest._retry = true
        isRefreshing = true

        try {
          const refreshRes = await axios.post(
            `${apiBaseUrl}/auth/refresh`,
            {},
            { withCredentials: true },
          )
          const newToken = refreshRes.data?.token
          if (newToken) {
            useAuthStore.getState().setToken(newToken)
            if (refreshRes.data?.role) {
              useAuthStore.getState().setRole(refreshRes.data.role)
            }
            originalRequest.headers.Authorization = `Bearer ${newToken}`
          }
          processQueue(null)
          return axiosInterceptorInstance(originalRequest)
        } catch (err) {
          processQueue(err, null)
          logoutUser()
          return Promise.reject(err)
        } finally {
          isRefreshing = false
        }
      } else {
        logoutUser()
      }
    }

    return Promise.reject(error)
  },
)

const logoutUser = () => {
  useAuthStore.getState().setToken(null)
  useAuthStore.getState().setRole(null)
  window.location.reload()
}

export default axiosInterceptorInstance
